import Swiper from "swiper";
import {EffectCoverflow, Navigation} from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {

    if (document.querySelector(".service-documents")) {
        const swiperServiceDocuments = new Swiper(".service-documents", {
            modules: [EffectCoverflow, Navigation],
            effect: 'coverflow',
            centeredSlides: true,
            slidesPerView: 2,
            loop: true,

            coverflowEffect: {
                rotate: 0,
                stretch: 100,
                depth: 400,
                modifier: 1,
                scale: 1,
                slideShadows: false,
            },
            navigation: {
                nextEl: ".service-documents .swiper-button-next",
                prevEl: ".service-documents .swiper-button-prev",
            },
        });
        swiperServiceDocuments.slideTo(1, 0);
    }

    if (document.querySelector(".talk-about-us-swiper")) {
        new Swiper(".talk-about-us-swiper", {
            modules: [Navigation],
            slidesPerView: 3,
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: ".talk-about-us-swiper+.blue-boxes__navigation .swiper-button-next",
                prevEl: ".talk-about-us-swiper+.blue-boxes__navigation .swiper-button-prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            }
        });
    }

});